const state = () => ({
  loading: false,
  loadingCount: 0
})

const actions = {
  setLoading({ commit }, payload) {
    commit("setLoading", payload)
  }
}

// getters
const getters = {}

// mutations
const mutations = {
  setLoading (state, loading) {
    if (loading) { state.loadingCount += 1}
    else {state.loadingCount -= 1}
    state.loading = state.loadingCount > 0? true : false
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
